import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import styles from "./ProductSelectorDB.module.scss";

const ProductSelectorDB = ({ value = "customer", onChange, label = "¿Desea ver todos los productos?", showLabel = true, isFetching = false }) => {
	const handleChange = (checked) => {
		const newValue = checked ? "all" : "customer";
		if (onChange) onChange(newValue);
	};

	const isCustomer = value === "all";

	return (
		<div className={styles.productToggle}>
			{showLabel && (
				<div className={styles.productToggleInfo}>
					<span className={styles.productToggleTitle}>{label}</span>
					<small className={styles.productToggleSubtitle}>
						<small className={styles.productToggleSubtitle}>
							{isFetching ? (
								<span>
									<span className={styles.spinner}></span>Cargando...
								</span>
							) : isCustomer ? (
								"Mostrando todos los productos disponibles en la base de datos"
							) : (
								"Mostrando solo productos en base a las compras"
							)}
						</small>
					</small>
				</div>
			)}

			<CustomInputSwitch value={isCustomer} onChange={handleChange} optionLeft="NO" optionRight="SI" />
		</div>
	);
};

export default ProductSelectorDB;
